import React from "react";
import {
  collectStorefrontContentMetadataLink,
  StorefrontContentMetadataProvider,
  useStorefrontContentMetadata,
} from "./StorefrontContentMetadataProvider";
import loadable from "@loadable/component";
import { branchContributionModeEnabled } from "theme/modules/ContributionMode";

export {
  collectStorefrontContentMetadataLink,
  StorefrontContentMetadataProvider,
  useStorefrontContentMetadata,
};

const RenderChildren = ({ children }) => {
  return <>{children}</>;
};

const LoadableStorefrontContent = loadable(
  () => {
    return import("./StorefrontContent");
  },
  {
    resolveStorefrontContent: (component) => {
      return component.default;
    },
    ssr: true,
  }
);

export default branchContributionModeEnabled(
  (StorefrontContent) => StorefrontContent,
  (StorefrontContent) => RenderChildren
)(LoadableStorefrontContent);
